import styled from 'styled-components'

export const StyledWrapper = styled.div`
  & > div > div > table {
    & > thead {
      position: static !important;
      background: transparent !important;
      & > tr > th {
        background: transparent !important;
        padding: 20px 10px !important;
      }
    }

    & > tbody {
      & > tr {
        background: #ffffff !important;
        & > th {
          padding: 10px !important;
        }
      }
    }
  }
`
